import type React from "react"
import "./TopicSelector.css"
import type { PostTagResponse } from "@/types/domain"

type TopicSelectorProps = {
  tags: PostTagResponse[]
  selectedTagId: number | null
  onSelect: (tag: PostTagResponse) => void
}

export const TopicSelector: React.FC<TopicSelectorProps> = ({
  tags,
  selectedTagId,
  onSelect,
}) => {
  return (
    <div className="topic-selector-container">
      <label className="topic-label">주제를 선택해주세요</label>
      <div className="topic-list">
        {tags
          .filter(tag => tag.visible)
          .sort((a, b) => a.displayOrder - b.displayOrder)
          .map(tag => (
          <button
            key={tag.id}
            className={`topic-chip ${
              selectedTagId === tag.id ? "selected" : ""
            }`}
            onClick={() => { onSelect(tag); }}
            type="button"
          >
            {tag.title}
          </button>
        ))}
      </div>
    </div>
  )
}
